<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="cookie-consent" [class.hidden]="!showCookieModal">
    <a class="cloose" (click)="closeNotice()">
        <img
            class="close-menu-img"
            alt="close menu"
            [src]="'/images/close.svg' | cdn"
    /></a>
    <div class="container">
        <p class="policy-info">
            {{ 'fe-cookie-consent_info' | translate }}
        </p>
        <div>
            <a
                class="link"
                href="https://privacy.ehi.com/es-us/home/cookie-policy.html"
            >
                {{ 'fe-cookie-consent_more-info' | translate }}</a
            >
        </div>
        <div>
            <a (click)="showModal()" class="link">
                {{ 'fe-cookie-consent_more-admin' | translate }}</a
            >
        </div>
    </div>
</div>
<fe-modal-cookies-consent
    *ngIf="showMoreInfo"
    (showModal)="closeMoreInfo()"
></fe-modal-cookies-consent>
